import { captureException } from "@sentry/browser";

// Some APIs are not async, but still need to call async function
// For many browser APIs, Sentry would have wrapped the call
//  - see: https://docs.sentry.io/platforms/javascript/configuration/integrations/browserapierrors/
// When we call the async function ourself, we need to catch the error
export function invokeAsync<T>(func: () => Promise<T>): void {
  (async (): Promise<void> => {
    try {
      await func();
    } catch (error) {
      captureException(error, {
        extra: error?.extra,
      });
      console.error("Error in non-awaited async function: ", error);
    }
  })();
}
